import { FC, useEffect, useState } from "react";
import { Connector, useAccount, useConnect } from "wagmi";

import { useStoreDispatch, useStoreSelector } from "../../../store/store";
import { blockchain } from "../../../settings";
import { useDisconnect } from "../../../hooks/useDisconnect";
// import { getInjectedProvider } from "../../../utils/chromia/getProvider";
import { Session } from "@chromia/ft4";


const WagmiComp: FC = () => {

	const { address, connector } = useAccount();
	const { userAddress } = useStoreSelector(store => store.app);
	const { session } = useStoreSelector(store => store.chromia);
	const { provider } = useStoreSelector(store => store.UI);
	const { error } = useConnect();
	const disconnect = useDisconnect(); 
	const { setUserAddress, clearAppState, clearChrState, clearModalsState, clearUIState } = useStoreDispatch();

	/* useEffect(() => {
		if (userAddress && connector && !session){
			asyncConnect(connector);
		}
		// eslint-disable-next-line
	}, [connector, session, userAddress]) */

	useEffect(() => {
		blockchain === 'chromia' && chrConnect(address, connector, session);
		// eslint-disable-next-line
	}, [connector, session, address])

	/* useEffect(() => {
		blockchain === 'binance' && bscConnect(userAddress, address, connector, config);
		// eslint-disable-next-line
	}, [connector, config, address, userAddress]) */

	useEffect(() => {
		// //console.log('connector: ', connector);
		// const changeAccount = () => {
			// //console.log('account changed');
			// window.location.reload()
		// }
		
		// //console.log('provider!!', provider)
		if (provider?.once) {
			// (provider as any).on('change', changeAccount);
			// (provider as any).on('disconnect', disconnect);
			// (provider as any).on("accountsChanged", changeAccount);
			// (provider as any).on("accountsChanged", () => disconnect());
			// (provider as any).on("disconnect", () => disconnect(true));
			provider.once("accountsChanged", () => disconnect());	// may stacks
			// provider.once("disconnect", () => disconnect(true));	// may stacks
			provider.once("disconnect", () => disconnect());	// may stacks
		}
		// return () => {
		// 	// (provider as any)?.off("change", changeAccount);
		// 	// (provider as any)?.off('disconnect', disconnect);
		// 	(provider as any).off("accountsChanged", changeAccount);
		// 	(provider as any).off("disconnect", disconnect);
		// }
		// eslint-disable-next-line
	}, [provider])

	useEffect(() => {
		if (!error) {
			return;
		}
		if (error.message === "Connector not found") {
			window.open("https://metamask.io/download", "_blank");
		}
	}, [error]);

	/* const bscConnect = async (
		storeAdress: string | null,
		newAddress: string | undefined,
		connector: Connector<any, any> | undefined,
		config: iConfig | null
	) => {
		if (newAddress && connector && config && !storeAdress){
			const bscConnect = await import('../../../utils/binance/connect');
			bscConnect.connect(connector, newAddress, config);
		}
	} */

	const chrConnect = async (
		userAddr: string | undefined,
		connector: Connector | undefined,
		session: Session | null
	) => {
		if (userAddr && connector && !session){
			const chrConnect = await import('../../../utils/Chromia/connect');
			chrConnect.connect(connector, userAddr);
		}
	}

	useEffect(() => {
		if (!address && userAddress) {
			clearAppState();
			clearChrState();
			clearModalsState();
			clearUIState();
			connector?.disconnect()
		}
		if (address !== userAddress)
			setUserAddress(address!);
		// loadChromia();

		// eslint-disable-next-line
	}, [address, userAddress])


	return null;
}

export default WagmiComp;
